import React from "react";

import { trackMixpanel, useAppType, useNavigate } from "utils";

import { Col, Icon, Row } from "components";

export const NavigationHeader = ({ link, title, fullWidth = false, mixpanelText }) => {
  const navigate = useNavigate();
  const { mobile } = useAppType();

  const handleClick = () => {
    trackMixpanel("ClickButton", { buttonText: mixpanelText });
    if (link) {
      navigate(link);
    } else {
      navigate(-1);
    }
  };

  // if no title is provided, it will stay blank
  // if no link is provided, the X icon works as a back button
  return (
    <section className={`multistep-form-header container ${fullWidth ? "" : "tiny"} ${mobile ? "margin-bottom-100" : "margin-bottom-200"}`}>
      <Row>
        <Col>
          <h5>
            {title} <Icon iconName="tabler/x" className="icon inline pointer" onClick={handleClick} />
          </h5>
        </Col>
      </Row>
    </section>
  );
};

export default NavigationHeader;
